import { CtaPill } from './primitives/CtaPill';
import { ArchCard } from './primitives/ArchCard';

export function FinalCta() {
    return (
        <div className="flex w-full justify-center px-[clamp(20px,5vw,72px)] pt-[clamp(56px,9vw,88px)]">
            <ArchCard
                data-reveal
                tone="paper"
                className="flex w-full max-w-[800px] flex-col items-center gap-8 border-x border-t border-border p-[clamp(32px,6vw,80px)] pt-[clamp(64px,10vw,120px)] text-center"
            >
                <h2 className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15] text-balance">
                    Let&rsquo;s find the first ten hours.
                </h2>
                <p className="max-w-lg text-[clamp(16px,1.4vw,18px)] leading-[1.55] text-muted-foreground">
                    Bring us a week of your practice. We&rsquo;ll come back with
                    what we&rsquo;d build first, what it would give you back,
                    and how long it would take. No obligation to go further.
                </p>
                <CtaPill href="/login" className="mt-4">
                    Book a working session
                </CtaPill>
                <p className="font-mono text-[11px] tracking-[0.04em] text-muted-foreground">
                    30 minutes with the people who&rsquo;d do the work.
                </p>
            </ArchCard>
        </div>
    );
}
